import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { isEmpty } from 'helpers/dataStructuresUtils';
import { getSubscriptionTitle } from '../helpers';

import { Text } from 'components/library';

import * as S from './styled';

import ClockIcon from '../img/clock.svg';

import { IPendingSubscription } from '../types';

import SubscriptionCardWrapper from './SubscriptionCardWrapper';
import StatusIcon from './StatusIcon';
import SubscriptionCardHeader from './SubscriptionCardHeader';
import { IncludedInYourPlanRow } from './IncludedInYourPlanRow';

const PendingSubscription = ({
  tabIcon,
  heading,
  state,
  subscriptionPeriod,
  upcomingProduct,
  subscriptionType,
  isUpgrade,
}: IPendingSubscription) => {
  const { t } = useTranslation();

  const paymentLabel = getSubscriptionTitle(subscriptionPeriod, false);
  const upcomingLabel = upcomingProduct && getSubscriptionTitle(upcomingProduct.subscription_period, false);

  return (
    <SubscriptionCardWrapper>
      <SubscriptionCardHeader Icon={tabIcon} heading={heading} />
      <S.Status>
        <ClockIcon />
        <Text type="caption" color="text-secondary">
          {t(`subscription.status.${state}`)}
        </Text>
        <Text type="caption" color="text-secondary">
          :
        </Text>
      </S.Status>
      <Text mb={20}>
        <Trans
          i18nKey="subscription.period"
          values={{ count: paymentLabel?.count, context: paymentLabel?.context, subscriptionType }}
        />
      </Text>
      {isUpgrade && <IncludedInYourPlanRow isCardRow />}
      <Text bold color="secondary-active" mb={4}>
        {t('subscription.pendingSubscription.title')}
      </Text>
      <Text type="small-text" color="text-secondary" mb={22}>
        {t('subscription.pendingSubscription.text')}
      </Text>
      {upcomingProduct && !isEmpty(upcomingProduct) && (
        <>
          <S.Status>
            <StatusIcon isActive={false} />
            <Text type="caption" color="text-secondary">
              {t('subscription.status.upcoming')}
            </Text>
            <Text type="caption" color="text-secondary">
              :
            </Text>
          </S.Status>
          <Text>
            <Trans
              i18nKey="subscription.period"
              values={{
                count: upcomingLabel?.count,
                context: upcomingLabel?.context,
                subscriptionType: t('subscription.type.subscription'),
              }}
            />
          </Text>
          {isUpgrade && <IncludedInYourPlanRow isCardRow />}
        </>
      )}
    </SubscriptionCardWrapper>
  );
};

export default PendingSubscription;
